import { head } from "../components/common/PageHeader.jsx";
import { btn } from "../components/forms/FormControls.jsx";
import { tableViews } from "../components/tables/RecordTable.jsx";
export function notFound() {
  return head(
    "RECORD UNAVAILABLE",
    "Page not found",
    "The record may have been archived or removed.",
    btn("Go to Dashboard", 'data-nav="dashboard"'),
  );
}
export default function NotFoundPage({ recordId } = {}) {
  return tableViews(notFound());
}
